<div class="blade-header box-wrapper">
    @if (title$ | async; as title) {
        <div class="text-small blade-title" [title]="title">
            {{ title }}
        </div>
    }

    <!-- An extra ngIf to prevent ExpressionChangedAfterItHasBeenCheckedError -->
    @if (isLoadingExtra$) {
        @if (isLoadingExtra$ | async; as isLoadingExtra) {
            <div class="blade-extra-information">
                @if (isLoadingExtra) {
                    <mat-spinner diameter="20"></mat-spinner>
                }
            </div>
        }
    }

    @if (hasParents) {
        <div class="blade-close">
            <button disableRipple="true" mat-icon-button (click)="close()">
                <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
        </div>
    }
</div>
<div class="blade-content">
    <router-outlet #outlet="outlet" [name]="name"></router-outlet>
</div>

<!-- An extra ngIf to prevent ExpressionChangedAfterItHasBeenCheckedError -->
@if (loading$) {
    @if (loading$ | async; as loading) {
        @if (loading) {
            <div class="loader-container">
                <places-spinner></places-spinner>
            </div>
        }
    }
}
